import { notificationService } from '@/services/NotificationService';
import type { NotificationCounts } from '@/types/notification';
import { defineStore } from 'pinia';

export const useNotificationStore = defineStore('notification', {
    state: () => ({
        counts: null as NotificationCounts | null,
        totalUnread: 0,
    }),

    actions: {
        async fetchCounts() {
            try {
                const response = await notificationService.getCounts();
                this.counts = response.data;
                this.totalUnread = Object.values(response.data).reduce((sum, count) => sum + count, 0);
            } catch {
                this.counts = null;
                this.totalUnread = 0;
            }
        },
    },
});
